import { FontAwesomeIconProps } from "@fortawesome/react-fontawesome"
import { Box, Typography } from "@mui/material"
import { CircleIcon } from "components/icons/CircleIcon"

export interface CContent {
  icon: FontAwesomeIconProps["icon"]
  size: FontAwesomeIconProps["size"]
  color: "primary" | "secondary" | "error" | "warning" | "info" | "success"
  backgroundColor: string
  message: string
}

const NoResultFound = (props: CContent) => {
  const { icon, size, color, message, backgroundColor } = props
  return (
    <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" paddingY={5}>
      <CircleIcon color={color} backgroundColor={backgroundColor} icon={icon} size={size} />
      <Typography align="center" variant="h4" marginTop={3} sx={{ whiteSpace: "pre-line" }}>
        {message}
      </Typography>
    </Box>
  )
}

export default NoResultFound
